import React from 'react';

import {StepHeader} from 'src/components/step-header';

import {Group} from '@pb/kit-component-group';
import {StickyElement} from '@pb/kit-component-sticky-element';


import {
    manageEntitlementsHeader,
    manageEntitlementsTitle,
} from '../manage-entitlements.module.styl';

type Props = {
    title: string,
    buttonsBlock: React.ReactNode,
    subtitle?: string,
};

export const ManageEntitlementsHeader = ({title, subtitle, buttonsBlock}: Props) => (
    <StickyElement className={manageEntitlementsHeader}>
        <div className={manageEntitlementsTitle}>
            <StepHeader title={title} subTitle={subtitle}/>
            <Group alignItems="center">
                {buttonsBlock}
            </Group>
        </div>
    </StickyElement>
);
